export default __webpack_public_path__ + "static/media/2014-AMcover.5b033aa0.png";